import React from 'react';
import '../../../Adminassets/white.css';

function PageContent({ children }) {
	return (
		<div className=" white app-content content overflow-hidden">
			<div className="content-overlay"></div>
			<div className="header-navbar-shadow" />
			<div className="container-xxl p-0">{children}</div>
		</div>
	);
}

export default PageContent;
